import { render, staticRenderFns } from "./LogisticDetails.vue?vue&type=template&id=548b7e41&"
import script from "./LogisticDetails.vue?vue&type=script&lang=js&"
export * from "./LogisticDetails.vue?vue&type=script&lang=js&"
import style0 from "./LogisticDetails.vue?vue&type=style&index=0&lang=css&"
import style1 from "./LogisticDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports